module.exports = __webpack_public_path__ + "img/04-Customer-Process.4a0e3e4b.svg";